/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.74"
        height="71.56"
        viewBox="0 0 82.74 71.56"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M6.92 18.5a1.5 1.5 0 1 1 2.17 2.07 21.88 21.88 0 0 0 15.45 37h33.29a1.502 1.502 0 0 1 .15 3H24.9A24.87 24.87 0 0 1 6.92 18.5Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M57.83 10.77a24.87 24.87 0 0 1 16.51 43.51 1.501 1.501 0 0 1-2-2.24 21.88 21.88 0 0 0-14.15-38.27H24.9a1.502 1.502 0 0 1-.14-3h33.07Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M32.12.44a1.5 1.5 0 0 1 2.22 2l-.1.11-9.72 9.71 9.92 9.92a1.48 1.48 0 0 1 .1 2l-.1.12a1.5 1.5 0 0 1-2 .1l-.11-.1-11-11a1.5 1.5 0 0 1-.1-2l.1-.11Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M48.5 47.25a1.5 1.5 0 0 1 2-.1l.11.1 10.78 10.77a1.5 1.5 0 0 1 .11 2l-.11.11-11 11a1.5 1.5 0 0 1-2.23-2l.11-.11 9.91-9.92-9.68-9.73a1.5 1.5 0 0 1-.1-2Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'TwoRevolvingArrowsOvalIcon';

export default Icon;
